// Single source of truth for the public "program pages" that classrooms map to.
// Used by:
//  - the classroom "Program page" dropdown (Classrooms tab)  -> uses `label`
//  - each program page (to pass its slug to <ProgramTeacherSection />)
//  - the dynamic Programs menu (maps a classroom's program_slug -> route/menuLabel)
//
// There is ONE entry per program. Several classroom rooms can map to the same page
// (e.g. Preschool A + B -> Preschool); the menu shows the page once and the page's
// "Our Educators" section groups the rooms under per-classroom headings. The old
// per-room "Room B" pages were consolidated away (see the consolidate_room_b migration).

export interface ProgramPage {
  slug: string;
  label: string;
  menuLabel: string;
  route: string;
}

export const PROGRAM_PAGES: ProgramPage[] = [
  { slug: "infant-program", label: "Infant", menuLabel: "Infant", route: "/infant-program" },
  { slug: "early-toddler-program", label: "Early Toddler", menuLabel: "Early Toddlers", route: "/early-toddler-program" },
  { slug: "middle-toddler-program", label: "Middle Toddler", menuLabel: "Middle Toddlers", route: "/middle-toddler-program" },
  { slug: "older-toddler-program", label: "Older Toddler", menuLabel: "Older Toddlers", route: "/older-toddler-program" },
  { slug: "pre-preschool-program", label: "Pre-Preschool", menuLabel: "Pre-Preschool", route: "/pre-preschool-program" },
  { slug: "preschool-program", label: "Preschool", menuLabel: "Preschool", route: "/preschool-program" },
  { slug: "prekindergarten-program", label: "Transitional Kindergarten", menuLabel: "Transitional Kindergarten", route: "/prekindergarten-program" },
  { slug: "preparatory-kindergarten-program", label: "Preparatory Kindergarten", menuLabel: "Preparatory Kindergarten", route: "/preparatory-kindergarten-program" },
  { slug: "kindergarten-program", label: "Kindergarten", menuLabel: "Kindergarten", route: "/kindergarten-program" },
  { slug: "toddler-program", label: "Toddler", menuLabel: "Toddler", route: "/toddler-program" },
];

const BY_SLUG = new Map(PROGRAM_PAGES.map((p) => [p.slug, p]));

/** Route for a program slug, or null if the slug is unknown. */
export function programRoute(slug: string | null | undefined): string | null {
  if (!slug) return null;
  return BY_SLUG.get(slug)?.route ?? null;
}

/** Short menu label for a program slug, or null if the slug is unknown. */
export function programMenuLabel(slug: string | null | undefined): string | null {
  if (!slug) return null;
  return BY_SLUG.get(slug)?.menuLabel ?? null;
}
